import { render, staticRenderFns } from "./position-dp-modal.vue?vue&type=template&id=58bf8627&scoped=true"
import script from "./position-dp-modal.vue?vue&type=script&lang=js"
export * from "./position-dp-modal.vue?vue&type=script&lang=js"
import style0 from "./position-dp-modal.vue?vue&type=style&index=0&id=58bf8627&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf8627",
  null
  
)

export default component.exports